import { Icon } from "components/icon/Icon";
import { useRootStore } from "store";
import { useIsMobile } from "hooks/use-is-mobile";
import config from "config/config";

import "./Footer.scss";

export default function Footer() {
  const { staticInformation } = useRootStore((state) => state.global)
  const office = staticInformation.headOfficeAddressInformation;
  const isMobile = useIsMobile();

  const licenceAgreementLink = <a
    href={config.static.licenseAgreement}
    rel="noreferrer"
    target="_blank"
  >
    Användarvillkor
  </a>

  const supportLink = <a
    target="_blank"
    rel="noreferrer"
    href="https://kundsupport.ludvig.se/support/home"
  >
    Support
  </a>

  const getHelpAndInfoSection = () => {
    if (isMobile) {
      return (
        <section className="footer-section">
          <div className="footer-section-header">Information / Hjälp</div>
          <div className="footer-section-content">
            {licenceAgreementLink}
            {supportLink}
          </div>
        </section>
      )
    } else {
      return (
        <>
          <section className="footer-section">
            <div className="footer-section-header">Information</div>
            <div className="footer-section-content">
              {licenceAgreementLink}
            </div>
          </section>

          <section className="footer-section">
            <div className="footer-section-header">Hjälp</div>
            <div className="footer-section-content">
              {supportLink}
            </div>
          </section>
        </>
      )
    }
  }

  return (
    <footer className="footer no-print">
      <div className="footer-inner">
        <section className="footer-section">
          <div className="footer-section-header">Huvudkontor</div>
          <div className="footer-section-content">
            <p>{office.title}, {office.streetAddress}, {office.zipcode} {office.city}</p>
          </div>
        </section>

        <section className="footer-section">
          <div className="footer-section-header">Kontakt</div>
          <div className="footer-section-content">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://ludvig.se/kontakta-oss"
            >
              Kontakta oss
            </a>
          </div>
        </section>

        {getHelpAndInfoSection()}

        <section className="footer-section">
          <div className="footer-section-header">Följ oss</div>
          <div className="footer-section-content footer-social-icons">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/ludvigco/"
            >
              <Icon
                className="circle-icon"
                name="fab fa-facebook-f circle-icon"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/ludvigco"
            >
              <Icon
                className="circle-icon"
                name="fab fa-linkedin circle-icon"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/ludvig.co/"
            >
              <Icon
                className="circle-icon"
                name="fab fa-instagram circle-icon"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/user/LRFKonsultMedia"
            >
              <Icon
                className="circle-icon"
                name="fab fa-youtube circle-icon"
              />
            </a>
          </div>
        </section>
      </div>
    </footer>
  );
}